// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/plugins/jvectormap/jquery-jvectormap-1.2.2.css
// module id = 1593
// module chunks = 81